import React, { useContext } from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';
import { ChevronRight, ChevronLeft } from 'react-feather';

import { PageContext } from '../PageContext';
import { v4tov3base } from '../../lib/mapV4toV3';

import * as styles from './SpeechBubble.module.scss';

type SpeechBubbleProps = {
  variant?: 'brand-b' | 'brand-c' | 'brand-c-reverse';
  speechBubbleText: string;
  className?: string;
  url?: string;
  linkText?: string;
  isReverse?: boolean;
};

const SpeechBubble = ({ className, speechBubbleText, variant, url, linkText, isReverse }: SpeechBubbleProps) => {
  const { websiteLocale } = useContext(PageContext);
  const { hasRightToLeftLanguage } = v4tov3base({...websiteLocale.attributes});
  return (
  <div
    data-testid="speechBubble"
    className={classnames(
      variant === 'brand-b' ? styles.redWrapper : styles.blueWrapper,
      variant === 'brand-b' ? styles.redTail : '',
      isReverse ? styles.blueTailReverse : styles.blueTail,
      className,
    )}
  >
    <h4 className="title is-4 has-text-weight-800 mb-1">{speechBubbleText}</h4>
    {linkText && (
      <div>
        <Link to={url ?? ''}>
          <span className="text-3 brand-a">{linkText ?? ''}</span>
        </Link>
        {hasRightToLeftLanguage ? <ChevronLeft size={12} className="black-3 ml-1 has-text-weight-bold" /> : <ChevronRight size={12} className="black-3 ml-1 has-text-weight-bold" />}
      </div>
    )}
  </div>
)};

export default SpeechBubble;
